import Vue from 'vue';
import gsap from 'gsap/all';

Vue.component('video-component', {
    props: {
        isEmbed: {
            type: Boolean,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            // video: null,
            videoPlaying: false,
            videoPaused: false,
            videoReady: false,
            videoInitialized: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        // this.setupVideo();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        async playVideo() {
            if (!this.video) {
                gsap.set(this.$el.querySelector('.plyr__video-embedding'), {
                    autoAlpha: 0,
                });

                await this.setupVideo();
            }

            this.video.play();
            this.videoPlaying = true;
        },

        async setupVideo() {
            // eslint-disable-next-line
            const { default: Plyr } = await import(/* webpackChunkName: "plyr" */ 'plyr');

            this.video = new Plyr(this.$refs.video, {
                settings: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                vimeo: {
                    byline: false, portrait: false, title: false, speed: true, controls: false, transparent: true,
                },
            });

            if (!this.video) {
                return;
            }

            this.videoInitialized = true;

            this.video.on('ready', () => {
                gsap.to(this.$el.querySelector('.plyr__video-embedding'), {
                    autoAlpha: 1,
                    delay: 1,
                    onComplete: () => {
                        this.videoReady = true;
                    },
                });
            });

            this.video.on('ended', (event) => {
                this.videoPlaying = false;
                this.videoPaused = true;
            });
        },
    },
});
